import {
    useState,
    useCallback,
} from 'react';

import { InteractionType } from '@azure/msal-browser';
import { useMsal, useMsalAuthentication } from "@azure/msal-react";

/**
 * Custom hook to call a web API using bearer token obtained from MSAL
 * @param {PopupRequest} msalRequest 
 * @returns 
 */
const useFetchWithMsal = (msalRequest) => {
    const { instance } = useMsal();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [data, setData] = useState(null);    const { result, error: msalError } = useMsalAuthentication(InteractionType.Popup, {
        ...msalRequest,
        account: instance.getActiveAccount(),
        redirectUri: process.env.REACT_APP_AUTH_REDIRECT_URI || 'http://localhost:3000/redirect'
    });

    /**
     * Execute a fetch request with the given options
     * @param {string} method: GET, POST, PUT, DELETE
     * @param {String} endpoint: The endpoint to call
     * @param {Object} data: The data to send to the endpoint, if any 
     * @returns JSON response
     */
    const execute = async (method, endpoint, data = null, isFile = false) => {
        if (msalError) {
            setError(msalError);
            console.error(msalError);
            return;
        }

        if (result) {
            try {
                let response = null;

                const headers = new Headers();
                const bearer = `Bearer ${result.accessToken}`;
                headers.append("Authorization", bearer);

                let options = {
                    method: method,
                    headers: headers,
                    body: null,
                };

                if (data) {
                    headers.append('Content-Type', 'application/json');
                    options.body = JSON.stringify(data);
                }

                setIsLoading(true);

                const fetchResponse = await fetch(endpoint, options);
                
                // Check for 404 errors
                if (fetchResponse.status === 404) {
                    // For 404 errors, return an object with status code but no message
                    console.log(`404 Error: ${endpoint} not found`);
                    setData({status: 404});
                    setIsLoading(false);
                    return {status: 404};
                }
                
                if (isFile) {
                    response = fetchResponse;
                    setData(response);
                } else {
                    response = await fetchResponse.json();
                    setData(response);
                }

                setIsLoading(false);
                return response;
            } catch (e) {
                setError(e);
                setIsLoading(false);
                throw e;
            }
        }
    };

    return {
        isLoading,
        error,
        data,
        execute: useCallback(execute, [result, msalError]), // to avoid infinite calls when inside a `useEffect`
    };
};

export default useFetchWithMsal;